/* eslint-disable angular/file-name,angular/window-service */
angular.module('zc.zenclerkS')
  .factory('ZcsMakerepeaterOem', zcsMakerepeaterOem);

zcsMakerepeaterOem.$inject = ['$cookies', '$location', '$q', '$rootScope', '$window', 'Api', 'Devise'];
function zcsMakerepeaterOem($cookies, $location, $q, $rootScope, $window, Api, Devise) {

  class ZcsMakerepeaterOem {

    static login(cookie) {
      return Api.post('/api/makerepeater/sessions', {cookie})
        .then(res => Devise.getCurrentUser({force: true}));
    }

    static handleLogin() {
      const cookie = $cookies.get(window.ZC_CONFIG.MAKEREPEATER_COOKIE);
      if(cookie) {
        return ZcsMakerepeaterOem.login(cookie);
      }

      if($window.parent) {
        // redirect parent frame because the content is in iframe
        $window.parent.location.href = window.ZC_CONFIG.MAKEREPEATER_LOGIN_URL;
      } else {
        $window.location.href = window.ZC_CONFIG.MAKEREPEATER_LOGIN_URL;
      }
      return $q.reject();
    }

    static providePublicApi() {
      $window.publicApi = {
        goTo(url) {
          $location.url(url);
          return $rootScope.$apply();
        }
      };
    }
  }

  return ZcsMakerepeaterOem;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/zcs_makerepeater_oem.service.js